import PageKey from 'config/PageKey';

export const translationUrlMapping = {
  common: 'shared-content',
  [PageKey.Jobs]: 'jobs-feed',
  [PageKey.Breakdown]: 'view-breakdown',
  [PageKey.Role]: 'view-role',
  [PageKey.FollowUp]: 'view-followup',
  [PageKey.SelfTapeUpload]: 'self-tape-upload',
  [PageKey.SelfTapeRequest]: 'jobs-view-self-tape-request-page',
  [PageKey.SelfTapeRequestNotifications]: 'jobs-self-tape-requests-dashboard',
};
